import { type FC } from 'react'
import { type DefaultProps } from '@egw/components'

export const BluetoothIcon: FC<DefaultProps> = ({ className, id, testId, ariaLabel }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      <path fill="#698679" d="m3.7 7.778.595-.541-.596-.542v1.083ZM3.7 5.305l.595-.541-.596-.541v1.082Z" />
      <path
        fill="#698679"
        d="M3.477 1.69A2.73 2.73 0 0 0 .75 4.416v3.166a2.73 2.73 0 0 0 2.727 2.727 2.73 2.73 0 0 0 2.728-2.727V4.417a2.73 2.73 0 0 0-2.728-2.728ZM4.96 7.008a.308.308 0 0 1 0 .455l-1.36 1.237a.308.308 0 0 1-.515-.228V6.751l-.559.568a.307.307 0 0 1-.435.004.308.308 0 0 1-.004-.435L2.96 6l-.874-.889a.308.308 0 1 1 .44-.431l.558.568V3.526a.308.308 0 0 1 .514-.228l1.36 1.237a.308.308 0 0 1 0 .456L3.849 6l1.11 1.009Z"
      />
      <path
        fill="#698679"
        fillRule="evenodd"
        d="M9.1 9.093a4.375 4.375 0 0 0 0-6.187.375.375 0 1 1 .53-.53 5.125 5.125 0 0 1 0 7.247.375.375 0 1 1-.53-.53Zm-1.06-1.06a2.875 2.875 0 0 0 0-4.067.375.375 0 1 1 .53-.53 3.625 3.625 0 0 1 0 5.127.375.375 0 1 1-.53-.53ZM6.98 6.971a1.375 1.375 0 0 0 0-1.945.375.375 0 1 1 .53-.53c.83.83.83 2.175 0 3.005a.375.375 0 1 1-.53-.53Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
